import { useEffect } from 'react'

interface UsePageNavigationProps {
  currentPageNumber: number
  totalPages: number
  onPageChange: (pageNumber: number) => void
  pageStep?: number
}

/**
 * Hook to handle keyboard shortcuts for page navigation
 * Arrow keys: Previous/Next page
 */
export function usePageNavigation({
  currentPageNumber,
  totalPages,
  onPageChange,
  pageStep = 1,
}: UsePageNavigationProps) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return
      }

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault()
          if (currentPageNumber > 1) {
            onPageChange(Math.max(1, currentPageNumber - pageStep))
          }
          break
        case 'ArrowRight':
          event.preventDefault()
          if (currentPageNumber < totalPages) {
            onPageChange(Math.min(totalPages, currentPageNumber + pageStep))
          }
          break
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [currentPageNumber, totalPages, onPageChange, pageStep])
}
